import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {IController, IModule, IOnChangesObject, IScope} from "angular";
import {Språk} from "felles/tjenester/i18n/Spraak";
import _ from "lodash";
import {gettextCatalog} from "angular-gettext";
import {dersomChangesInneholder} from "../../felles/stoettefunk/angularHjelpemetoder";
import {GruppeRessurs} from "../../felles/tjenester/ressurser/GruppeRessurs";
import {l} from "../../types/typescriptdefinisjoner_lederplan";
import {Kontekst} from "../../felles/tjenester/Kontekst";

const css = require('./gruppeSpraakvelger.scss');

export class GruppeSpråkvelgerKontroller implements IController {

    static registrerKomponent(angular: IModule) {
        angular.component('gruppeSpraakvelger', {
            bindings: {gruppe: '<'},
            controller: GruppeSpråkvelgerKontroller.forInjisering(),
            template: require('./gruppeSpraakvelger.html')
        });
    }

    static forInjisering() {
        return [regNavn.ng.$scope, regNavn.gettext.gettextCatalog, GruppeRessurs.regNavn, Kontekst.regNavn, GruppeSpråkvelgerKontroller]
    }

    constructor(private $scope: IScope, private gettextCatalog: gettextCatalog, private gruppeRessurs: GruppeRessurs, private kontekst: Kontekst) {
    }

    gruppe: l.GruppeModell //settes via bindings/$onChanges 
    spraakKode: string; 

    erKunVisning = false;
    valgtSpraak: Språk;
    


    onchanageSpraak() {
        if (this.erKunVisning) return;

        this.valgtSpraak = Språk.finnSpråkFraTag(this.spraakKode);
        if (_.isNil(this.valgtSpraak)) return;
        this.gruppeRessurs.oppdaterSpråk(this.gruppe.id, this.valgtSpraak)
    }

    init(): void {
        this.erKunVisning = ! this.kontekst.inneharTilgangsrolleIGruppe(l.TilgangsrolleMedlem.skrive, this.gruppe.id);
        this.spraakKode = this.gruppe.oppsett.spraak;
        this.valgtSpraak = Språk.finnSpråkFraTag(this.spraakKode);

    }

    $onChanges(endringer: IOnChangesObject): void {
        dersomChangesInneholder(endringer, 'gruppe', () => {
            this.init()
        });
    }
    
    
    hentValgtSpaakOversatt():string{
        if (this.valgtSpraak.servertag == 'nb') return this.gettextCatalog.getString('Bokmål');
        if (this.valgtSpraak.servertag == 'nn') return this.gettextCatalog.getString('Nynorsk');
        if (this.valgtSpraak.servertag == 'en') return this.gettextCatalog.getString('Engelsk');
        return "Norsk" // bør aldri skje
    }

}
